<template>
  <b-modal title="Create reserve" :visible="true" @ok="myModal = false" @hidden="$emit('hidden')" @hide="stop" ref="createReserveModal">
    <b-form @submit.prevent="createReserve()">
      <b-form-group
        label="Check-in"
        vertical="true">
        <b-row>
        <b-col lg="6">
          <v-date-picker
            mode='single'
            v-model='reserve.startDate'
            :input-props='{class:"form-control", readonly: true }'>
            <b-form-group
              slot-scope='{ inputValue, updateValue }'>
              <b-input-group>
                <b-form-input
                  type="text"
                  data-lpignore=true
                  placeholder='Check-in Date' 
                  autocomplete="off"
                  :value='inputValue'
                  @input.native='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                  @change.native='updateValue($event.target.value, { formatInput: true, hidePopover: false })'
                  @keydown.esc.native.stop="updateValue($event.target.value, { formatInput: false, hidePopover: true })">
                </b-form-input>
                <!-- Attach Right button -->
                <b-input-group-append>
                  <b-button variant="primary" style="z-index: auto" :disabled="!reserve.startDate" @click='reserve.startDate = new Date()'>Reset</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </v-date-picker>
        </b-col>
        <b-col lg="6">
          <div class="form-input">
            <el-time-picker
              style="width: 100%"
              v-model="reserve.startTime"
              size="medium"
              :clearable="false"
              placeholder="Check-in Time"
              format="HH:mm"
              value-format="HH:mm:ss"
              :picker-options="{format: 'HH:mm'}">
            </el-time-picker>
          </div>
        </b-col>
        </b-row>
      </b-form-group>

      <b-form-group
        label="Check-out"
        vertical="true">
        <b-row>
        <b-col lg="6">
          <v-date-picker
            mode='single'
            v-model='reserve.stopDate'
            :input-props='{class:"form-control", readonly: true }'>
            <b-form-group
              slot-scope='{ inputValue, updateValue }'>
              <b-input-group>
                <b-form-input
                  type="text"
                  data-lpignore=true
                  placeholder='Check-out Date' 
                  autocomplete="off"
                  :value='inputValue'
                  @input.native='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                  @change.native='updateValue($event.target.value, { formatInput: true, hidePopover: false })'
                  @keydown.esc.native.stop="updateValue($event.target.value, { formatInput: false, hidePopover: true })">
                </b-form-input>
                <!-- Attach Right button -->
                <b-input-group-append>
                  <b-button variant="primary" style="z-index: auto" :disabled="!reserve.stopDate" @click='resetStopDate()'>Reset</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </v-date-picker>
        </b-col>
        <b-col lg="6">
          <div class="form-input">
            <el-time-picker
              style="width: 100%"
              v-model="reserve.stopTime"
              size="medium"
              :clearable="false"
              placeholder="Check-in Time"
              format="HH:mm"
              value-format="HH:mm:ss"
              :picker-options="{format: 'HH:mm'}">
            </el-time-picker>
          </div>
        </b-col>
        </b-row>
      </b-form-group>
      
      <b-form-group
        label="Client"
        :vertical="true">
        <b-row>
          <b-col sm="12">
            <multiselect v-model="selectedClient" :options="clients" :max="1" :multiple="true" placeholder="Select one" :custom-label="namePhone" label="name" track-by="id" :disabled="loadingClientsBool"></multiselect>
            <!-- <div v-else-if="loadingClients == true"><i class="fa fa-refresh fa-spin"></i></div>
            <b-alert show variant="danger" style="width: 100%;" v-else>{{loadingApartments}}</b-alert> -->
          </b-col>
          <!-- <b-col sm="2">
            <b-button type="button" variant="primary" @click="createClientModal = true"><i class="fa fa-plus"></i></b-button>
          </b-col> -->
        </b-row>
      </b-form-group>

      <b-form-group
        label="Apartment"
        :vertical="true">
        <multiselect v-model="selectedApartment" :options="apartments" :max="1" :multiple="true" placeholder="Select one" label="name" track-by="id" :disabled="loadingApartmentsBool"></multiselect>
        <!-- <div v-else-if="loadingApartments == true"><i class="fa fa-refresh fa-spin"></i></div>
        <b-alert show variant="danger" style="width: 100%;" v-else>{{loadingApartments}}</b-alert> -->
      </b-form-group>
      
      <b-form-group
        label="Room"
        :vertical="true">
        <multiselect v-model="selectedRoom" :options="rooms" :max="1" :multiple="true" placeholder="Select one" label="number" track-by="id" :disabled="isDisabled || loadingRoomsBool"></multiselect>
      </b-form-group>

      <b-form-group
        label="Price"
        label-for="price"
        :vertical="true">
        <money
          v-model="reserve.price"
          v-bind="moneyFormat"
          class="form-input form-control">
        </money>
      </b-form-group>

      <b-form-group
        label="Source"
        label-for="source"
        :vertical="true">
        <b-form-input id="source" type="text" autocomplete="source" v-model="reserve.source" @keypress.native="error = null"></b-form-input>
      </b-form-group>

      <b-form-group
        label="Code"
        label-for="code"
        :vertical="true">
        <b-form-input id="code" type="text" autocomplete="code" v-model="reserve.code" @keypress.native="error = null"></b-form-input>
        <button type="submit" hidden/>
      </b-form-group>
    </b-form>
    <transition name="fade">
      <b-alert show variant="danger" style="width: 100%;" v-if="error" v-html="error.message"></b-alert>
    </transition>
    <transition name="fade">
      <b-alert show variant="danger" style="width: 100%;" v-if="loadingError" v-html="loadingErrorMessage"></b-alert>
    </transition>
    <div slot="modal-footer">
      <b-button type="button" :disabled="loadingError" variant="success" class="ladda-button" id="create-button" data-style="expand-right" @click="createReserve()"><i class="fa fa-plus"></i>&nbsp;Create reserve</b-button>
    </div>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import * as Ladda from 'ladda'
import api from '../../api'
import config from '../../config'
import VCalendar from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment'

import TimePicker from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
// configure language
locale.use(lang)

import Multiselect from 'vue-multiselect'
import { Money } from 'v-money'

Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['DD/MM/YYYY'],
    dayPopover: 'L',
    data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD']
  },
  popoverVisibility: 'focus'
});

Vue.use(TimePicker)

export default {
  name: 'CreateReserve',
  components: {
    Multiselect,
    Money
  },
  data () {
    return {
      reserve: {
        startDate: new Date(),
        startTime: "15:00:00",
        stopDate: null,
        stopTime: "11:00:00",
        price: 0.00,
        source: '',
        code: ''
      },
      apartments: [],
      selectedApartment: [],
      rooms: [],
      selectedRoom: [],
      clients: [],
      selectedClient: [],
      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: ' €',
        precision: 2,
        masked: false
      },
      creatingReserve: false,
      createButton: null,
      error: null,
      loadingClients: false,
      loadingApartments: false,
      loadingRooms: false
    }
  },
  created() {
    this.resetStopDate()
    this.getClients()
    this.getApartments()
  },
  mounted: function() {
    this.createButton = Ladda.create(document.querySelector( '#create-button' ))
  },
  watch: {
    selectedApartment: function(selected) {
      if (selected.length) this.getRooms(selected[0].id)
      else {
        this.rooms = []
        this.selectedRoom = []
      }
    }
  },
  computed: {
    isDisabled() {
      if (this.selectedApartment.length) return false
      else return true
    },
    loadingError() {
      if (this.loadingClients || this.loadingApartments || this.loadingRooms) {
        return true
      }
      else return false
    },
    loadingErrorMessage() {
      if (this.loadingClients || this.loadingApartments || this.loadingRooms) {
        let error = ''
        if (this.loadingClients) error += `<div>Clients: ${this.loadingClients}`
        if (this.loadingApartments) error += `<div>Apartments: ${this.loadingApartments}`
        if (this.loadingRooms) error += `<div>Rooms: ${this.loadingRooms}`
        return error
      }
      else return false
    },
    loadingClientsBool() {
      if (this.loadingClients) return true
      else return false
    },
    loadingApartmentsBool() {
      if (this.loadingApartments) return true
      else return false
    },
    loadingRoomsBool() {
      if (this.loadingRooms) return true
      else return false
    }
  },
  methods: {
    resetStopDate: function () {
      let stopDate = new Date()
      stopDate.setDate(stopDate.getDate() + 1)
      this.reserve.stopDate = stopDate
    },
    getClients() {
      this.loadingClients = true
      api.request("get", config.serverURI + 'clients')
        .then(response => {
          this.loadingClients = false
          this.clients = response.data
        })
        .catch(error => {
          let errorMessage = this.getError(error)
          if (errorMessage) {
            this.loadingClients = errorMessage
          } else {
            this.loadingClients = "Clients: Error loading!"
          }         
        })
    },
    getError: function(error) {
      if (error.response) {
        if (error.response.data) {
          if (error.response.data.message) {
            return error.response.data.message
          }
          return error.response.data
        }
      }
      return null
    },
    nameEmail: function(client) {
      return '' + client.name + ' - ' + client.email
    },
    namePhone: function(client) {
      return '' + client.name + ' - ' + client.phone
    },
    getApartments() {
      this.loadingApartments = true
      api.request("get", config.serverURI + 'apartments')
        .then(response => {
          this.loadingApartments = false
          this.apartments = response.data
          if (this.apartments.length === 1) {
            this.selectedApartment = []
            this.selectedApartment.push(this.apartments[0])
          }
        })
        .catch(error => {
          let errorMessage = this.getError(error)
          if (errorMessage) {
            this.loadingApartments = errorMessage
          } else {
            this.loadingApartments = "Apartments: Error loading!"
          }  
        })
    },
    getRooms(apartmentID=null) {
      api.request("get", config.serverURI + 'rooms', null, {apartmentID: apartmentID})
        .then(response => {
          this.rooms = response.data
          if (this.rooms.length === 1) {
            this.selectedRoom = []
            this.selectedRoom.push(this.rooms[0])
          }
        })
        .catch(error => {
          let errorMessage = this.getError(error)
          if (errorMessage) {
            this.loadingRooms = errorMessage
          } else {
            this.loadingRooms = "Rooms: Error loading!"
          }  
        })
    },
    createReserve: function() {
      this.error = false
      this.creatingReserve = true
      this.createButton.start()
      let reserve = this.reserveRequestBody()
      if (reserve) {
        api.request('post', config.serverURI + 'reserves', reserve)
          .then(response => {
            this.creatingReserve = false
            this.createButton.stop()
            this.$emit('created',response.data)
            this.$refs.createReserveModal.hide()
          })
          .catch(error => {
            this.creatingReserve = false
            this.createButton.stop()
            if (error.response) {
              this.error = {
                message: error.response.data.error
              }
            } else {
              this.error = {
                message: 'Server error!'
              }
            }
          })
      } else {
        this.createButton.stop()
        this.creatingReserve = false
      }
      
    },
    reserveRequestBody: function() {
      try {
        return {
          roomID: this.selectedRoom[0].id,
          startDate: `${moment(this.reserve.startDate).format("DD-MM-YYYY")} ${this.reserve.startTime}`,
          stopDate: `${moment(this.reserve.stopDate).format("DD-MM-YYYY")} ${this.reserve.stopTime}`,
          reserveDate: `${moment(new Date()).format("DD-MM-YYYY HH:mm:ss")}`,
          clientID: this.selectedClient[0].id,
          price: this.reserve.price,
          source: this.reserve.source,
          code: this.reserve.code
        }
      } catch (error) {
        console.log(error)
        this.error = {
          message: "Invalid reserve!"
        }
        return null
      }
    },
    stop: function(event) { //prevents modal close while waiting for the API response
      if (this.creatingReserve ) event.preventDefault()
    }
  }
}
</script>

<style scoped>
  .fade-enter-active {
    transition: all .8s ease;
  }
  .fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    /* transform: translateX(10px); */
    opacity: 0;
  }
</style>